import React, { useEffect, useState } from 'react';
import { adminApi } from '../../services/api';

const fmtDate = (d: string) =>
  new Date(d).toLocaleString('en-ZA', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });

export const AdminUnallocatedScreen: React.FC = () => {
  const [rows, setRows] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [allocFor, setAllocFor] = useState<string | null>(null);
  const [search, setSearch] = useState('');
  const [results, setResults] = useState<any[]>([]);
  const [msg, setMsg] = useState('');

  const load = async () => {
    setLoading(true);
    try { setRows(await adminApi.unallocated()); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const doSearch = async (q: string) => {
    setSearch(q);
    if (q.trim().length < 2) { setResults([]); return; }
    setResults(await adminApi.searchUsers(q));
  };

  const allocate = async (notifId: string, userId: string) => {
    setMsg('');
    try {
      await adminApi.allocate(notifId, { userId });
      setMsg('Allocated and wallet credited.');
      setAllocFor(null); setSearch(''); setResults([]);
      await load();
    } catch (e: any) {
      setMsg(e?.response?.data?.message || 'Allocation failed');
    }
  };

  const dismiss = async (notifId: string) => {
    const note = window.prompt('Reason for dismissing this payment?') || '';
    try { await adminApi.dismiss(notifId, note); await load(); }
    catch (e: any) { setMsg(e?.response?.data?.message || 'Dismiss failed'); }
  };

  if (loading) return <p>Loading…</p>;

  return (
    <div>
      {msg && <p className="admin-muted">{msg}</p>}
      {rows.length === 0 && <p className="admin-muted">No unallocated payments.</p>}
      {rows.length > 0 && (
        <table className="admin-table">
          <thead>
            <tr><th>Date</th><th>Amount</th><th>Shop Code</th><th>Reference</th><th>Sender</th><th>Reason</th><th></th></tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <React.Fragment key={r.id}>
                <tr>
                  <td>{fmtDate(r.processedAt)}</td>
                  <td>R {Number(r.parsedAmount ?? 0).toFixed(2)}</td>
                  <td>{r.shopCode || '-'}</td>
                  <td>{r.parsedRef || '-'}</td>
                  <td>{r.fromAddress}</td>
                  <td className="admin-muted">{r.statusReason || r.status}</td>
                  <td>
                    <button className="admin-btn allocate" onClick={() => { setAllocFor(allocFor === r.id ? null : r.id); setSearch(''); setResults([]); }}>Allocate</button>
                    <button className="admin-btn dismiss" onClick={() => dismiss(r.id)}>Dismiss</button>
                  </td>
                </tr>
                {allocFor === r.id && (
                  <tr>
                    <td colSpan={7}>
                      <input
                        style={{ width: '100%', padding: '0.5rem', marginBottom: '0.5rem' }}
                        placeholder="Search user by name, phone, shop code, or wallet id"
                        value={search}
                        onChange={(e) => doSearch(e.target.value)}
                      />
                      {results.map((u) => (
                        <div key={u.id} style={{ display: 'flex', justifyContent: 'space-between', padding: '0.4rem 0', borderBottom: '1px solid #eee' }}>
                          <span>{u.name} · {u.phone} · {u.mainWalletId || 'no main wallet'}</span>
                          <button className="admin-btn allocate" onClick={() => allocate(r.id, u.id)} disabled={!u.mainWalletId}>Credit R {Number(r.parsedAmount ?? 0).toFixed(2)}</button>
                        </div>
                      ))}
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};
